import React, { useState } from 'react'
import { useMutation } from 'react-apollo-hooks'
import { Button, Modal } from 'antd'
import updateEcerOneParticipantMutation from '~/graphql/mutations/updateEcerOneParticipant.gql'

const UpdateEcerOneParticipantBtn = (props) => {
  const { eventId, participantId, disabled, size, children } = props
  const [loading, setLoading] = useState(false)
  const [updateEcerOneParticipant] = useMutation(updateEcerOneParticipantMutation)

  const handleClick = async () => {
    if (!eventId || !participantId) return
    setLoading(true)
    try {
      const res = await updateEcerOneParticipant({
        variables: { eventId, participantId }
      })
      const ok = res && res.data && res.data.updateEcerOneParticipant
      if (ok) {
        Modal.success({ title: 'ECER updated' })
      } else {
        Modal.error({ title: 'ECER update failed' })
      }
    } catch (e) {
      Modal.error({ title: 'Error', content: e.message })
    } finally {
      setLoading(false)
    }
  }

  return (
    <Button
      icon="reload"
      size={size}
      loading={loading}
      disabled={disabled || !eventId || !participantId}
      onClick={handleClick}
    >
      {children || 'Update ECER'}
    </Button>
  )
}

export default UpdateEcerOneParticipantBtn
